webpackJsonp([264086094094354],{

/***/ 764:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/valentines-day/"},"excerpt":"Valentine’s Day is only a couple of weeks away. Remember when you bought your honey that new ironing board? It didn’t go over so well, did…","timeToRead":1,"frontmatter":{"title":"Valentine's Day is Coming!","tags":["birds","holidays","romance"]}}}]}},"pathContext":{"tag":"holidays"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-holidays-d36c25bdc04b43ac85f0.js